import { useQuery } from "react-query";

import { QUERY_KEYS } from "../../../constants/queryKeys";
import { LoyaltyApi } from "../../../services";

export type UseLoyaltyPrizeParams = {
  consumer_uuid?: string;
  reward_uuid?: string;
};

export const useLoyaltyPrize = ({ consumer_uuid, reward_uuid }: UseLoyaltyPrizeParams) => {
  return useQuery(
    [QUERY_KEYS.loyaltyPrize, consumer_uuid, reward_uuid],
    () => {
      if (!reward_uuid) {
        throw new Error("reward_uuid is required");
      }

      if (consumer_uuid) {
        return LoyaltyApi.init().getRewardExtended({ consumer_uuid, reward_uuid });
      } else {
        return LoyaltyApi.init().getReward({ reward_uuid });
      }
    },
    {
      enabled: Boolean(reward_uuid),
    }
  );
};
